import { render, staticRenderFns } from "./ghdy2.vue?vue&type=template&id=24317b40&scoped=true"
import script from "./ghdy2.vue?vue&type=script&lang=js"
export * from "./ghdy2.vue?vue&type=script&lang=js"
import style0 from "./ghdy2.vue?vue&type=style&index=0&id=24317b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24317b40",
  null
  
)

export default component.exports